import styles from "./ContactUs.module.css";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <div className={styles.container}>
      <div className={styles.nav}>
        <Link to="/" className={`btn-primary ${styles.link}`}>
          Home
        </Link>
        <Link to="/about" className={`btn-primary ${styles.link}`}>
          About
        </Link>
        <Link to="/contact-us" className={`btn-primary ${styles.link}`}>
          Contact Us
        </Link>
        <Link to="/home" className={`btn-primary ${styles.button}`}>
          Login/Signup
        </Link>
      </div>
      <div> </div>
      <div className={styles.modal}>
        <img
          id="main-logo"
          className="logo"
          src="https://impactrepublic.github.io/helium/images/logo.png"
          with={150}
          height={150}
          style={{ marginBottom: 50 }}
          alt="Helium-logo"
        />
        <h4 className={styles.title}>Contact Us</h4>
        <p>
          If you have any questions or comments, please contact us. We’re always
          ready to help!
        </p>
        <a
          href="mailto:hello@humanelevation.com"
          className={`btn-primary ${styles.button}`}
        >
          Contact Us
        </a>
      </div>
      <footer className={styles.footer}>
        386 Park Avenue South, 18th Floor NY, NY 10016{" "}
        <strong>P. 212-441-0000</strong>
        <a href="mailto:hello@humanelevation.com">hello@humanelevation.com</a>
      </footer>
    </div>
  );
};

export default ContactUs;
